export default function BlogHead({ title }){
    return (
        <div className="blog-head">
            <h2 className="blog-title">{ title.split('\n').map((line, i)=> <> { i > 0 && <br/> }<span>{ line }</span> </>) }</h2>
        </div>
    )
}